import { OrExpression, RuleExpression, RuleValueTypes } from "../../../api/models";
import RuleExpressionEditor from "../expression";
import { Button, Card } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';

export interface Props {
    expression: OrExpression;
    onUpdate: (e:OrExpression) => void;
    disabledRuleValueTypes?: RuleValueTypes[] | undefined
}

const OrExpressionEditor = (props: Props) => {
    function onUpdate(idx: number, expr: RuleExpression) {
        const orExpr = new OrExpression();
        orExpr.expressions = [...props.expression.expressions.slice(0, idx), expr, ...props.expression.expressions.slice(idx + 1)];
        props.onUpdate(orExpr);
    }

    function onAdd() {
        const orExpr = new OrExpression();
        orExpr.expressions = [...props.expression.expressions, new RuleExpression()];
        props.onUpdate(orExpr);
    }

    function onRemove(idx: number) {
        const orExpr = new OrExpression();
        orExpr.expressions = [...props.expression.expressions.slice(0, idx), ...props.expression.expressions.slice(idx+1)];
        props.onUpdate(orExpr);
    }

    return (
        <div>
            <Button style={{margin: '5px'}} size="small" type="primary" icon={<PlusCircleOutlined />} onClick={onAdd}>Add to OR</Button>
            <Card>
                {props.expression.expressions.map((e, idx) =>
                (
                    <div key={idx}>

                        <Card>
                            <Button icon={<DeleteOutlined />} style={{marginBottom: '5px'}} onClick={() => {
                                onRemove(idx);
                            }}/>
                            <RuleExpressionEditor expression={e} onUpdate={(expr) => onUpdate(idx, expr)} disabledRuleValueTypes={props.disabledRuleValueTypes} />
                        </Card>
                        {idx != props.expression.expressions.length - 1 &&
                            <span><strong>OR</strong></span>}
                    </div>
                ))}
            </Card>
        </div>
    );
};

export default OrExpressionEditor;
